<template>
  <span
    class="text-h6"
  >
    <q-chip
      class="bg-negative q-px-md q-py-sm"
      square
      :class="$isColorDark(currentSite.negativeColor) ? 'text-white' : 'text-dark'"
    >
      Overdue
    </q-chip>
    <q-chip
      class="bg-positive q-px-md q-py-sm"
      square
      :class="$isColorDark(currentSite.positiveColor) ? 'text-white' : 'text-dark'"
    >
      Prepare Now
    </q-chip>
    <q-chip
      class="bg-info q-px-md q-py-sm"
      square
      :class="$isColorDark(currentSite.infoColor) ? 'text-white' : 'text-dark'"
    >
      Upcoming
    </q-chip>
  </span>
</template>

<script>
export default {
  name: 'KitchenDisplayLegendChips',
  configuration: ['currentSite']
}
</script>
